// extracted by mini-css-extract-plugin
export default {"wrapper":"Login_wrapper__AGc7m","loginButton":"Login_loginButton__-+hWU","logo":"Login_logo__pZJJR"};